import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 19.99H8C6.9 19.99 6 19.0906 6 17.9913V12.0949C6 11.5253 6.44 11.0456 7 10.9956V8.98688C7 6.2386 9.24 4 12 4C14.76 4 17 6.2386 17 8.99688V11.0056C17.56 11.0556 18 11.5253 18 12.1049V18.0012C18 19.1006 17.1 20 16 20V19.99ZM8 17.9913H16V12.9944H8V17.9913ZM9 10.9956H15V8.99688C15 7.34791 13.65 5.99875 12 5.99875C10.35 5.99875 9 7.34791 9 8.99688V10.9956Z" fill={ fill || 'currentColor' } />
    </svg>
);
